<template>
  <div>
    <div class="space-x-20 dd flex items-center justify-between">
      <div
        v-for="(item, key) in items"
        :key="key"
        :class="{ active: current === key }"
        class="pb-1 px-1 cur"
        @click="current = key"
      >
        <!-- {{ item }} -->
        {{ key }}
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watchEffect } from "@vue/composition-api";

export default {
  props: { items: {} },
  setup(props, ctx) {
    const current = ref("全部商品");

    watchEffect(() => {
      ctx.emit("update:option", current.value);
    });
    return { current };
  },
};
</script>
<style scoped lang="scss">
.dd > div {
  cursor: pointer;
}
.dd > div:hover {
  display: inline-block;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}
.active {
  --tw-border-opacity: 1;
  border-color: rgba(21, 186, 99, var(--tw-border-opacity));
  border-bottom-width: 2px;
  padding-bottom: 2px;
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}
</style>
